import { ChevronLeft, ChevronRight, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";

/* Shown when a commentary simply has nothing written on this chapter (not an access issue). */
export function CommentaryNoNotes({ name, book, chapter, prev, next, onGo, compact = false }) {
  const label = (t) => `${t.book} ${t.chapter}`;
  return (
    <div className={`rounded-2xl border border-dashed border-border bg-card text-center ${compact ? "p-5" : "p-10"}`} data-testid="commentary-no-notes">
      <BookOpen className="mx-auto h-6 w-6 text-gold" />
      <h2 className={`mt-3 font-serif font-semibold text-foreground ${compact ? "text-lg" : "text-2xl"}`}>{name} has no notes on {book} {chapter}</h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">This commentary is still available — it just doesn't cover this chapter. Jump to the nearest chapter {name} did write about.</p>
      <div className="mt-5 flex flex-wrap justify-center gap-2">
        {prev && <Button variant="outline" size={compact ? "sm" : "default"} className="rounded-full" onClick={() => onGo(prev)} data-testid="commentary-no-notes-prev"><ChevronLeft className="mr-1 h-4 w-4" /> Previous with notes: {label(prev)}</Button>}
        {next && <Button size={compact ? "sm" : "default"} className="rounded-full bg-primary text-primary-foreground" onClick={() => onGo(next)} data-testid="commentary-no-notes-next">Next with notes: {label(next)} <ChevronRight className="ml-1 h-4 w-4" /></Button>}
      </div>
    </div>
  );
}
